// Use the same approach as the theme's main header sticky behavior
$(document).ready(function() {
    if ($(window).width() <= 768) return; // Desktop only
    
    const $consolidatedHeader = $('.tab-menu-promo-bar-header');
    if (!$consolidatedHeader.length) return;
    
    let lastScroll = 0;
    let headerHeight = $consolidatedHeader.outerHeight();
    let didScroll = false;
    
    function consolidated_header_sticky() {
        const scroll = $(window).scrollTop();
        const $mainHeader = $('.hdr_wrap');
        const mainHeaderIsSticky = $mainHeader.hasClass('sticky_hdr');
        
        if (scroll > headerHeight && scroll > lastScroll) {
            // Scrolling down past header height - remove visible class
            $consolidatedHeader.removeClass('consolidated-visible animated fadeInDown');
            
            // Reset main header position when hiding consolidated header
            if (mainHeaderIsSticky) {
                $mainHeader.css('top', '0px');
            }
        } else if (scroll <= headerHeight) {
            // Near top - remove all sticky classes
            $consolidatedHeader.removeClass('consolidated-sticky consolidated-visible animated fadeInDown');
            
            // Reset main header position
            $mainHeader.css('top', '');
        } else if (scroll < lastScroll) {
            // Scrolling up - add sticky and show with animation
            $consolidatedHeader.addClass('consolidated-sticky consolidated-visible animated fadeInDown');
            
            // Position main header below consolidated header if it's sticky
            if (mainHeaderIsSticky) {
                // Use the actual consolidated header height for positioning
                const consolidatedHeight = $consolidatedHeader.outerHeight();
                $mainHeader.css('top', consolidatedHeight + 'px');
            }
        }
        
        lastScroll = scroll;
    }
    
    $(window).scroll(function() {
        didScroll = true;
    });
    
    // Use same interval approach as theme
    setInterval(function() {
        if (didScroll) {
            consolidated_header_sticky();
            didScroll = false;
        }
    }, 250);
});